module.exports = __webpack_public_path__ + "3fefd5a10b7bdfb7c57ba22d792de2f9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg85.jpeg
// module id = 100
// module chunks = 0